
























































































import { Coupon } from '@/resource/coupon/coupon.model';
import { getToken } from '@/utils/cookie';
import { SubscriptionType } from '@/utils/subscription/subscription.util';
import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '../common/MainButton.vue';
import ModalSignInUp from '../common/modal/ModalSignInUp.vue';
import PremiumBenefitItem, { PremiumBenefit } from './PremiumBenefit.vue';
import ModalDiscount from '../common/modal/ModalDiscount.vue';

@Component({
  components: { PremiumBenefitItem, MainButton, ModalSignInUp, ModalDiscount },
})
export default class PremiumCard extends Vue {
  @Prop({ default: 'premium-card' })
  parentClass!: string;

  @Prop({ default: 'Main Button' })
  buttonLabel!: string;

  @Prop({ default: 'Batalkan langganan pada bila-bila masa' })
  bottomLabel!: string;

  @Prop({ default: 'Badge Here' })
  badgeLabel!: string;

  @Prop({ default: null })
  pricelabel!: number | null;

  @Prop({ default: null })
  priceDiscountlabel!: number | null;

  @Prop({ required: true })
  benefits!: PremiumBenefit[];

  @Prop({ default: false })
  isSkipRegister: boolean;

  @Prop({ default: null })
  subscriptionType!: SubscriptionType;

  @Prop({ default: null })
  selectedCoupon: Coupon | null;

  @Prop({ required: true })
  updateSelectedCoupon: (coupon: Coupon) => void;

  @Prop({ required: true })
  onSubscriptionSubmit: () => Promise<void> | null;

  get isLoggedin() {
    return getToken() ? true : false;
  }

  openSignInUpModal: any = null;
  openDiscountModal: any = null;

  openSignInUpModalAdd(openModal: any) {
    this.openSignInUpModal = openModal;
  }

  openDiscountModalAdd(openModal: any) {
    this.openDiscountModal = openModal;
  }

  async subscribeClicked() {
    if (!this.isLoggedin && !this.isSkipRegister) {
      this.openSignInUpModal && this.openSignInUpModal();
    } else {
      await this.onSubscriptionSubmit();
    }
  }

  roundNumber(number: number | null) {
    if (number) {
      return Math.round(number * 100) / 100;
    } else {
      0;
    }
  }
}
